import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { WINDOW } from '@grid-ui/common';
import { LoggingService } from '@maplecroft-ui/logging';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly window = inject(WINDOW);
  private readonly loggingService = inject(LoggingService);

  public handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      void this.loggingService.log(`${error.message} - Automatically reloading the page`, { level: 'debug' });

      setTimeout(() => this.window.location.reload(), 500);

      return;
    }

    // Unwrap HttpErrors that are within promise rejections
    if (!(error instanceof HttpErrorResponse) && error.rejection && error.rejection instanceof HttpErrorResponse) {
      error = error.rejection;
    }

    // swallow 403 errors as they will result in a redirect to login page and are an "expected" scenario
    // 404 errors are again "expected" so we're blocking those from being logged
    if (error.status === 403 || error.status === 404) {
      return;
    }

    void this.loggingService.logError(error);

    console.error(error);
  }
}
